import Request from '../../common/api/request';
import ServiceResultFactory from '../../common/api/ServiceResultFactory';

const graphqlUrl = baseUrl => (
  `${baseUrl}graphql`
);

const getProducerDetails = (baseApiUrl, producerId, interfaceLocale) => {
  const query =
`query {
producerDetails(producerId: "${producerId}")
{
id,
firstName,
lastName,
profileImage,
multilingual{
  locale,
  description
},
eventEditionId,
representingCompanies {
  id
  organisationId
  multilingual{
    displayName
    locale
  }
}
exhibitingCompanies {
  id
  organisationId
  multilingual{
    displayName
    locale
  }
}
products {
  id
  exhibitingOrganisationId
  imageUrl
  isInnovative
  multilingual {
    title
    description
    locale
  }
  }
}
}`;
  return Request.graphqlRequest(graphqlUrl(baseApiUrl), query)
    .then(response => ServiceResultFactory.fromGraphqlSuccess(response, interfaceLocale, 'producerDetails'));
};

export default {
  getProducerDetails
};

